import React from 'react'
import { connect } from 'react-redux'
import { Alert } from 'reactstrap'
import { Link } from 'react-router-dom';

import './LoginContainer.css'
import LoginForm from '../LoginForm'
import * as loginStore from '../store'

export const links = [
  <Link to="/forgot-password">Forgot Password?</Link>
];

class LoginContainer extends React.Component {

  renderAlert() {
    const { state } = this.props.location

    if (state && state.fromResetPassword) {
      return <Alert color="info">You may now login with your new password.</Alert>
    }
    return null
  }

  render() {
    return (
      <div className="LoginContainer" >
        <div className="LoginForm">
          {this.renderAlert()}
          <LoginForm onSubmit={this.props.handleSubmit} />
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const { login } = loginStore.Actions
  const { history } = ownProps
  return {
    handleSubmit: (values) => {
      dispatch(login(values, () => {history.push('/')}))
    }
  }
}

export default connect(null, mapDispatchToProps)(LoginContainer)



// WEBPACK FOOTER //
// ./src/components/layouts/login/LoginContainer/index.jsx